import { useContext, useEffect, useRef, useState } from "react";
import { FreeMode, Mousewheel, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { CraftPredictionContext } from "pages/CraftPrediction";
import CraftBuyInMarketplaceBtn from "components/crafting/CraftBuyInMarketplaceBtn";

const CraftPredictionEligibles = ({ parentSwiper }) => {
  const { eligibles, isEligiblesLoading, activeBlock, craftBlocks } =
    useContext(CraftPredictionContext);
  const eligiblesRef = useRef(null);

  const [temporaryEligibles, setTemporaryEligibles] = useState(eligibles);

  const stopParent = () => (parentSwiper.current.enabled = false);
  const startParent = () => (parentSwiper.current.enabled = true);

  const getEligiblesText = () => {
    switch (activeBlock) {
      case "Event":
        return "Eligible events";
      case "Identity":
        return "Eligible identities";
      case "Trigger":
        return "Eligible triggers";
      case "Prize":
        return "Prize Cards Owned";
      default:
        break;
    }
  };

  useEffect(() => {
    if (eligiblesRef.current) {
      eligiblesRef.current.update();
    }

    if (craftBlocks[0].value && activeBlock === 'Event') {
      setTemporaryEligibles(eligibles.filter((item) => item.title.includes(craftBlocks[0].value.properties.filter((property) => property.title === "Team")[0].text)))
    } else {
      setTemporaryEligibles(eligibles);
    }
  }, [eligibles]);

  const getComponent = () => {
    if (activeBlock === "Identity") {
      return <p className="card-details__craft-empty">Under Construction</p>;
    }

    if (isEligiblesLoading) {
      return (
        <p className="card-details__craft-empty">
          <span className="card-details__craft-empty-loader">
            Loading in process...this may take a moment
          </span>
        </p>
      );
    }

    if (!eligibles || eligibles.length < 1) {
      return (
        <p className="card-details__craft-empty">
          Select an {activeBlock.toLowerCase()}
        </p>
      );
    }

    return (
      <Swiper
        onSwiper={(swiper) => {
          eligiblesRef.current = swiper;
        }}
        className="card-details__craft-list-wrapper"
        direction="vertical"
        slidesPerView={"auto"}
        freeMode={true}
        mousewheel={{
          releaseOnEdges: true,
        }}
        scrollbar={{
          draggable: true,
          snapOnRelease: false,
        }}
        modules={[FreeMode, Mousewheel, Scrollbar]}
        spaceBetween={6}
        onTouchStart={stopParent}
        onTouchEnd={startParent}
      >
        <SwiperSlide>
          <ul className="card-details__craft-list">
            {temporaryEligibles && temporaryEligibles.map((item, index) => (
              <li className="card-details__craft-item" key={index}>
                <button
                  className={`card-details__craft-item-button card-details__craft-item-button--eligibles ${
                    item.marketplace_id !== -1
                      ? "card-details__craft-item-button--eligibles-buy"
                      : ""
                  } `}
                  onClick={(e) => {
                    if (item.marketplace_id !== -1) {
                      e.currentTarget.classList.toggle("active");
                      eligiblesRef.current.update();
                    }
                  }}
                >
                  {activeBlock === "Prize" ? (
                    <>
                      <span title={item.prize_amount}>
                        ${item.prize_amount}
                      </span>
                      <span className="card-details__craft-item-status">
                        Owned
                      </span>
                    </>
                  ) : (
                    <>
                      <span title={item.title}>{item.title}</span>
                      <span
                        className={`card-details__craft-item-status ${
                          item.ownership.toLowerCase() === "not owned"
                            ? "card-details__craft-item-status--not"
                            : ""
                        }`}
                      >
                        {item.ownership}
                      </span>
                    </>
                  )}
                </button>
                {item.marketplace_id !== -1 && (
                  <CraftBuyInMarketplaceBtn
                    status={item.ownership}
                    id={item.marketplace_id}
                    name={item.title}
                    type={activeBlock.toLowerCase()}
                  />
                )}
              </li>
            ))}
          </ul>
        </SwiperSlide>
      </Swiper>
    );
  };

  return (
    craftBlocks.some((item) => item.value !== null) &&
    <section
      className="card-details__card card-details__card--craft-info"
      onMouseEnter={stopParent}
      onMouseLeave={startParent}
    >
      <h3 className="card-details__title">{getEligiblesText()}</h3>
      {getComponent()}
    </section>
  );
};

export default CraftPredictionEligibles;
